/**
 * Názvy sekcií workflow v cust006 / cust020 (dopyt, akvizícia).
 */

export const CRM_NEXT_STEP_LABEL_KEY = 'CustomerLevels.Marker.NextStep';

const INSPECTION_LABEL_KEYS = Object.freeze({
  quote_request: 'CustomerLevels.Task.Inspection.inquiry',
  acquisition: 'CustomerLevels.Task.Inspection.acquisition',
});

export function crmInspectionSectionLabelKey(ticketType) {
  return INSPECTION_LABEL_KEYS[ticketType] || 'CrmCommunication.Inspection.Acquisition';
}
